import { render } from "./DepositPopup.vue?vue&type=template&id=5d693637&scoped=true&ts=true"
import script from "./DepositPopup.vue?vue&type=script&lang=ts"
export * from "./DepositPopup.vue?vue&type=script&lang=ts"

import "./DepositPopup.vue?vue&type=style&index=0&id=5d693637&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d693637"]])

export default __exports__